import { gql } from '@apollo/client';

export const GET_ME = gql`
query Membership {
  me {
    # Every organisation this person belongs to — what the Switch organisation entry is
    # shown or hidden by. Cheap: this query is already read by every role hook, so the
    # switcher costs no extra request.
    organisations {
      id
      name
    }
    organisation {
      name
      # Whether the working organisation supports somebody — derived from Supporter rows, not a
      # column. Drives the nav: a supporter organisation runs no classes, so class, reporting and
      # attendance entries there lead to pages that can only be empty.
      isSupportingOrganisation
      # Whether this organisation runs classes — a live course, or tag groups set up to
      # describe courses. Replaces the negation of isSupportingOrganisation as the gate on
      # every class-shaped entry: "do you support somebody" and "do you run classes" are
      # different questions that happen to coincide on every organisation alive today.
      runsClasses
      currentBlockTag {
        id
        code
        name
      }
      nextBlockTag {
        id
        code
        name
      }
      membership {
        isAdmin
        isTeacherPersona
        isCenterManager
        isCourseAdmin
        isContentReviewer
        isPartnerLeadership
        isPartnerMembershipOfficer
        canAccessLeadership
        # The gate on the "Add person" form. The server's own answer, not isAdmin ||
        # isCenterManager rebuilt here — which roles carry CREATE_PERSON is per-organisation
        # data edited on /admin/roles, so a copy on this side goes stale without saying so.
        canCreatePerson
        # The gate on the Create class page. Was isAdmin here while the mutation behind the
        # page asked for a capability — the menu was the stricter of the two.
        canCreateCourse
        # Whether taking registers is all they do — the gate on the stripped-down phone
        # view. Not isTeacherPersona, which is "not an admin and sees few courses" and so
        # is true of almost every non-admin, including people with no courses at all.
        isTeacherOnly
      }
    }
  }
}`;
